<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import Detail from './components/detail.vue'
import ShopSpecialContentAdd from '@/components/shopSpecialContentAdd.vue'

export default {
  name: "AssaySell",
  data() {
    return {
      data: [],
      page: {
        total: 0,
        size: 20,
        current: 1
      },
      tableKey: 0,
      loading: false,
      coalShopName: '',
      coalProductName: '',
      listingStatus: '',
      showPreview: false,
      srcList: [],
      laboratoryId: '',
      coalLaboratoryList: []
    }
  },
  components: { ElImageViewer, Detail, ShopSpecialContentAdd },
  mounted() {
    this.fetchCoalLaboratory()
    this.init()
    this.$validate.ToDocumentTitle()
  },
  methods: {
    init() {
      this.$set(this, 'loading', true)
      const params = {
        laboratoryId: this.laboratoryId || undefined,
        pageNum: this.page.current,
        pageSize: this.page.size,
        coalShopName: this.coalShopName || undefined,
        coalProductName: this.coalProductName || undefined,
        listingStatus: this.listingStatus || undefined
      }
      this.$axios.post('/laboratory/report_release/page', params).then((res) => {
        this.$set(this, 'loading', false)
        this.$set(this, 'data', res.data.data.list)
        this.$set(this.page, 'total', res.data.data.total)
        this.tableKey += 1
      }).catch(() => {
        this.$set(this, 'loading', false)
      })
    },
    fetchCoalLaboratory() {
      const params = {
        pageNum: 1,
        pageSize: 1000,
        conditions: [],
        sorts: []
      }
      this.$axios.post('/paas/coal_laboratory/list', params).then((res) => {
        this.coalLaboratoryList = res.data.data.list
      })
    },
    handleSizeChange(val) {
      this.page.size = val
      this.init()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.init()
    },
    fetchInit() {
      this.page.current = 1
      this.init()
    },
    handleLookImageUrl(row) {
      this.srcList = [row.imageUrl]
      this.showPreview = true
    },
    handleImageClose() {
      this.showPreview = false
    },
    handleDelete(row) {
      const params = {
        id: row.id
      }
      this.$axios.post('/laboratory/report_release/delete', params).then(() => {
        this.$message.success({ showClose: true, message: '删除成功' })
        this.init()
      })
    },
    handleUpdateState(row, type) {
      const params = {
        id: row.id,
        listingStatus: type,
        remark: ''
      }
      this.$axios.post('/laboratory/report_release/listing', params).then(() => {
        this.$message.success({ showClose: true, message: type === 'InTest' ? '上架成功' : '下架成功' })
        this.init()
      })
    },
    handleLookLine(row, type) {
      this.$refs.detailRef.display({ data: row, type: type })
    },
    handleAddSpecial(row) {
      this.$refs.shopSpecialContentAddRef.display({ row: row, type: 'LaboratoryReport' })
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          sums[columnIndex] = '合计'
        } else if (['pricing', 'clickNum', 'orderNum', 'income', 'unsettledAccountsNum'].includes(column.property)) {
          let totalValue = 0
          data.forEach(item => {
            const value = Number(item[column.property])
            if (!isNaN(value)) {
              totalValue += value
            }
          })
          sums[columnIndex] = totalValue
          if (column.property === 'pricing' || column.property === 'income') {
            sums[columnIndex] = '￥' + sums[columnIndex]
          } else if (column.property === 'clickNum') {
            sums[columnIndex] = sums[columnIndex] + ' 次'
          } else if (column.property === 'orderNum' || column.property === 'unsettledAccountsNum') {
            sums[columnIndex] = sums[columnIndex] + ' 份'
          }
        } else {
          sums[columnIndex] = '-'
        }
      })
      return sums
    }
  }
}
</script>

<template>
  <div style="padding: 20px; height: 100%; box-sizing: border-box">
    <div class="cf" style="margin-bottom: 10px;">
      <div class="fl" style="font-size: 16px; display: flex; align-items: center; height: 32px;">
        <el-select v-model="laboratoryId" size="mini" placeholder="请选择化验室" style="margin-right: 10px; width: 200px"
          clearable @change="fetchInit" filterable>
          <el-option v-for="item in coalLaboratoryList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-input v-model="coalShopName" size="mini" placeholder="输入煤源" style="margin-right: 10px; width: 200px"
          clearable @change="fetchInit"></el-input>
        <el-input v-model="coalProductName" size="mini" placeholder="输入煤种" style="margin-right: 10px; width: 200px"
          clearable @change="fetchInit"></el-input>
        <el-select v-model="listingStatus" size="mini" placeholder="请选择状态" style="margin-right: 10px; width: 200px"
          clearable @change="fetchInit">
          <el-option label="上架" value="Y"></el-option>
          <el-option label="下架" value="N"></el-option>
        </el-select>
      </div>
      <div class="fr">
        <el-tooltip class="item" effect="dark" content="查询" placement="top">
          <el-button size="mini" @click="init()" circle icon="el-icon-search">
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <el-table :data="data" border size="mini" style="width: 100%" height="85%" v-loading="loading" show-summary
      highlight-current-row :summary-method="getSummaries" :key="tableKey">
      <template #empty>
        <el-empty></el-empty>
      </template>
      <el-table-column type="index" label="序号" width="50" align="center" show-overflow-tooltip />
      <el-table-column prop="code" label='报告单编号' width="100" align="center" show-overflow-tooltip />
      <el-table-column prop="laboratoryName" label='化验室' minWidth="150" align="center" show-overflow-tooltip sortable />
      <el-table-column prop="coalShopName" label='煤源' minWidth="100" align="center" show-overflow-tooltip sortable />
      <el-table-column prop="coalProductName" label='煤种' width="100" align="center" show-overflow-tooltip sortable />
      <el-table-column prop="productCode" label='二级煤种' width="100" align="center" show-overflow-tooltip sortable />
      <el-table-column prop="submissionTime" label='报告生成时间' width="140" align="center" show-overflow-tooltip sortable />
      <el-table-column prop="pricing" label='单价' width="80" align="center" sortable>
        <template #default="scope">
          {{ scope.row.pricing ? '￥' + scope.row.pricing : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="clickNum" label='浏览量' width="90" align="center" sortable>
        <template #default="scope">
          <template v-if="scope.row.clickNum">
            <span style="cursor: pointer; color: blue" @click="handleLookLine(scope.row, '1')">
              {{ scope.row.clickNum }} 次
            </span>
          </template>
          <template v-else>
            -
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="orderNum" label='售卖数' width="90" align="center" sortable>
        <template #default="scope">
          <template v-if="scope.row.orderNum">
            <span style="cursor: pointer; color: blue" @click="handleLookLine(scope.row, '2')">
              {{ scope.row.orderNum }} 份
            </span>
          </template>
          <template v-else>
            -
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="income" label='预估金额' width="95" align="center" sortable>
        <template #default="scope">
          {{ scope.row.income ? '￥' + scope.row.income : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="listingStatus" label='状态' width="80" align="center" sortable>
        <template #default="scope">
          <el-tag :type="scope.row.listingStatus === 'Y' ? 'success' : 'danger'" size="mini">
            {{ scope.row.listingStatus === 'Y' ? '上架' : '下架' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="unsettledAccountsNum" label="未分账" width="95" align="center" sortable>
        <template #default="scope">
          <template v-if="scope.row.unsettledAccountsNum">
            <span style="color: red">
              {{ scope.row.unsettledAccountsNum }} 份
            </span>
          </template>
          <template v-else>
            -
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="imageUrl" label='化验报告' width="100" align="center">
        <template #default="scope">
          <el-button type="text" size="mini" @click="handleLookImageUrl(scope.row)" v-if="scope.row.imageUrl">
            电子报告
            <i class="el-icon-document-copy"></i>
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label='操作' width="160" align="center" fixed="right">
        <template #default="scope">
          <el-popconfirm v-if="scope.row.listingStatus === 'N'" trigger="click" style="margin-right: 10px"
            @confirm="handleUpdateState(scope.row, 'Y')" title="确定 上架 该条化验报告吗？">
            <template #reference>
              <el-button size="mini" type="text">上架</el-button>
            </template>
          </el-popconfirm>
          <el-button v-if="scope.row.listingStatus === 'Y'" size="mini" type="text"
            @click="handleAddSpecial(scope.row)">
            绑定专题
          </el-button>
          <el-popconfirm v-if="scope.row.listingStatus === 'Y'" trigger="click" style="margin: 0 10px"
            @confirm="handleUpdateState(scope.row, 'N')" title="确定 下架 该条化验报告吗？">
            <template #reference>
              <el-button size="mini" type="text" style="color: #F56C6C">下架</el-button>
            </template>
          </el-popconfirm>
          <el-popconfirm trigger="click" @confirm="handleDelete(scope.row)" title="确定 删除 该条化验报告吗？">
            <template #reference>
              <el-button size="mini" type="text" style="color: #F56C6C">删除</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <ElImageViewer v-if="showPreview" :url-list="srcList" :on-close="handleImageClose" />
    <detail ref="detailRef" @init="init" />
    <shopSpecialContentAdd ref="shopSpecialContentAddRef" />
    <div style="text-align: left; padding: 10px 0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.current"
        :page-sizes="[20, 50, 80, 100, 200, 500, 1000]" :page-size="page.size" :total="page.total" background
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<style scoped></style>
